<template>
	<section id="importacoes">
		<Notification ref="notif" :closed="true" corner="bottom-right" />
		<container textButton="Voltar" pathName="/objetos">
			<div class="relatorio">
				<DropdownMenu name="reportMenu"
					text="Download dos modelos de importação"
					:loading="generatingReport"
					:items="tipos.map(el => {
						return {
							text: el.nome,
							handler: function () { downloadModel(el.id) }
						}
					})"
				/>
			</div>

			<div class="main-content">
				<div class="import">
					<div class="container">
						<div class="title">
							<span class="fas fa-file-import"></span> Nova Importação
						</div>

						<form>
							<multiselect class="multiselect-import" v-model="selectedTipo" placeholder="Selecione um tipo de objeto" :options="tipos" key="id" trackBy="id" label="nome"></multiselect>

							<multiselect
								:options="[{id: 1, nome: 'Cadastrar', type: 'importExcelObjects'}, {id:2, nome: 'Alterar', type: 'updateExcelObjects'}]"
								data-tooltip-content="Ao realizar uma importação, lembre-se de que todos os objetos da planilha devem possuir o mesmo tipo de objeto"
								v-model="acao" placeholder="Selecione a operação a ser realizada"
								label="nome"
								class="multiselect-import tooltip info" />

							<label class="custom-upload">
								<span class="fake-input">Selecione um arquivo</span>
								<span class="fake-button">Buscar</span>
								<input type="file" @input="[updateFakeInput($event.target.files[0]), arquivo = $event.target.files]" class="input-file" name="input-file"/>
							</label>

							<div class="acoes">
								<a class="import-btn" href="javascript:void(0)"  @click.stop="importExcel">Importar</a>
							</div>
						</form>
					</div>
				</div>

				<div class="list">
					<table v-if="!this.loading">
						<tr>
							<th class="center">Data</th>
							<th class="left">Usuário</th>
							<th class="left">Ação</th>
							<th class="left">Tipo</th>
							<th class="center">Status</th>
						</tr>

						<tr @click="detailed = importacao" v-for="importacao in importacoes" :key="importacao.id">
							<td class="center">{{ getDate(importacao.data) }}</td>
							<td class="left">{{ importacao.usuarioNome }}</td>
							<td class="left">{{ importacao.acao }}</td>
							<td class="left">{{ getTipo(importacao.tipo) }}</td>
							<td class="center"><span :class="['fas', ...getStatusClass(importacao.status, importacao.erro)]"></span></td>
						</tr>
					</table>

					<div v-else class="list-error">
						<load-content />
					</div>
				</div>

				<div class="details">
					<div class="container">
						<div class="title">
							<span class="fas fa-file-alt"></span> Detalhes da importação
						</div>

						<div class="content" v-if="detailed">
							<span class="detailed-info"><b>Importado por:</b> {{ detailed.usuarioNome }}</span>
							<span class="detailed-info"><b>Em:</b> {{ getDate(detailed.data, true) }}</span>
							<span class="detailed-info"><b>Status da importação:</b> {{ getStatus(detailed.status, detailed.erro) }}</span>
							<span class="detailed-info" v-if="getStatus(detailed.status, detailed.erro) === 'Sucesso'">
									<b>Relatório de exportação: </b>
									<a href="javascript:void(0)" class="download-report-btn" @click="objectReport(detailed.id)">Download do arquivo retorno</a>
									<span class="download-status object-report"></span>
							</span>
							--
							<span class="detailed-info"><b>Arquivo importado:</b> {{ detailed.nomeArquivo }}</span>
							<span class="detailed-info"><b>Tipo dos dados importados:</b> {{ getTipo(detailed.tipo) }}</span>
							<span class="detailed-info"><b>Operação realizada:</b> {{ detailed.acao }}</span>
							<span class="detailed-info" v-if="getStatus(detailed.status, detailed.erro) === 'Falha'">
							--<br />
									<b>Relatório de erros:</b>
									<div class="error-box">
										<span v-for="(error, i) in JSON.parse(detailed.erro)" :key="i" class="error-item">{{ error.erro }}</span>
									</div>
							</span>
						</div>

						<div class="content-error" v-else>
							Selecione um registro na tabela ao lado para visualizar os detalhes
						</div>
					</div>
				</div>
			</div>
		</container>
	</section>
</template>

<script>
import getUniqueID from '@/helpers/getUniqueID'

// components
import container from '@/components/shared/Container'
import LoadContent from '@/components/shared/LoadContent'
import DropdownMenu from '@/components/shared/DropdownMenu'

// services
import { tipos } from '@/services/tipos'
import { importacoes } from '@/services/importacoes'
import { objetos } from '@/services/objetos'

export default {
	name: 'importacoesObjetos',
	components: { container, LoadContent, DropdownMenu },
	data () {
		return {
			arquivo: undefined,
			tipos: [],
			selectedTipo: null,
			importacoes: [],
			acao: { id: 1, nome: 'Cadastrar', type: 'importExcelObjects' },
			detailed: null,
			generatingReport: false
		}
	},
	created () {
		this.$connect(`${process.env.VUE_APP_WEBSOCKET_API}?${getUniqueID()}`, { format: 'json' })
		this.laodImportList()
		this.$options.sockets.onmessage = async (e) => {
			const resp = JSON.parse(e.data)
			if (resp.type === 'import-response') {
				const data = resp.data[0]
				if (!data.erro) {
					const exported = await objetos.processReport({ importacao: data.id })
					await this.laodImportList()
					window.open(exported.data.arquivo, '_self')
				} else {
					console.logs('Erros no preenchimento da planilha:', data.erro)
				}
			} else if (resp.type === 'received-request-response') {
				await this.laodImportList()
			} else if (resp.type === 'error-message') {
				await this.laodImportList()
			}
		}
	},
	methods: {
		downloadModel (typeId) {
			this.generatingReport = true

			tipos.exportModel(typeId).then(data => {
				if (data.data.gerado) {
					location.href = data.data.arquivo
					this.generatingReport = false
				}
			}).catch(resp => {
				this.generatingReport = false
			})
		},
		objectReport (importId) {
			document.querySelector('.download-status.object-report').classList.add('downloading')

			importacoes.objectReport(importId).then(data => {
				if (data.data.gerado) {
					location.href = data.data.arquivo
					document.querySelector('.download-status.object-report').classList.remove('downloading')
				}
			}).catch(resp => {
				document.querySelector('.download-status.object-report').classList.remove('downloading')
			})
		},
		updateFakeInput (files) {
			document.querySelector('.fake-input').innerHTML = files.name
		},
		getDate (date, addHours) {
			const dateObj = new Date(date)

			const d = dateObj.getDate().toString().padStart(2, '0')
			const m = (dateObj.getMonth() + 1).toString().padStart(2, '0')
			const y = dateObj.getFullYear().toString()

			const h = (dateObj.getHours() + 3).toString().padStart(2, '0') // +3h bater com o padrão do banco de dados (o JS remove 3h por conta do GMT-3)
			const mi = dateObj.getMinutes().toString().padStart(2, '0')
			const s = dateObj.getSeconds().toString().padStart(2, '0')

			const fullDate = 	`${d}/${m}/${y}`
			const time = `${h}:${mi}:${s}`

			return addHours ? `${fullDate} às ${time}` : fullDate
		},
		getStatusClass (status, error) {
			if (error) {
				error = JSON.parse(JSON.stringify(error))
			}

			if (status.toLowerCase() === 'finalizado' && !error.length) {
				return ['fa-check']
			} else if (status.toLowerCase() === 'finalizado') {
				return ['fa-times-circle']
			} else if (status.toLowerCase() === 'falha') {
				return ['fa-times-circle']
			} else {
				return ['fa-spinner', 'fa-spin']
			}
		},
		getStatus (status, error) {
			if (error) {
				error = JSON.parse(error)
			}

			if (status.toLowerCase() === 'finalizado' && !error.length) {
				return 'Sucesso'
			} else if (status.toLowerCase() === 'falha') {
				return 'Falha'
			} else if (status.toLowerCase() === 'finalizado') {
				return 'Falha'
			} else {
				return 'Processando'
			}
		},
		getTipo (tipo) {
			const objTipo = this.tipos.filter(el => el.id === tipo)

			if (objTipo.length) {
				return objTipo[0].nome
			} else {
				return 'Tipo não encontrado'
			}
		},
		importExcel () {
			const csv = this.arquivo[0]
			const reader = new FileReader()
			reader.readAsDataURL(csv)
			const token = localStorage.getItem('repov4-token')
			reader.onload = e => {
				this.$socket.sendObj({ operation: this.acao.type, data: { arquivo: e.target.result, tipo: this.selectedTipo.id, idUsuario: this.$auth.user().id, acao: this.acao, token } })
			}
		},
		async laodImportList () {
			const reqs = [tipos.find(), importacoes.find()]
			this.loading = true

			Promise.all(reqs).then(data => {
				this.tipos = data[0].data
				this.importacoes = data[1].data

				this.loading = false
			}).catch(res => {
				this.loading = false
			})
		}
	}
}
</script>

<style lang="scss" scoped>
	.main-content {
		display: grid;
		grid-template-columns: 1.5fr 3.5fr;
		grid-template-rows: auto 1fr;
		grid-template-areas: "import list"
												"details list";
		gap: 5px 10px;
		margin-top: 10px;

		@media all and (max-width: 800px) {
			grid-template-columns: 1fr;
			grid-template-rows: unset;
			grid-template-areas: "import" "list" "details";
		}

		.import, .list, .details {
			color: #4F5C6B;

			&.import {
				grid-area: import;
				margin: 5px 0;

				.container {
					background-color: $main-color;
					border-radius: $border-radius;

					& > div, & > form {
						padding: 10px;

						&.title {
							color: #FFF;
							border-bottom: 1px solid #FFF;

							.fas {
								margin-right: 5px;
							}
						}

						.multiselect-import {
							height: 45px;
							margin-bottom: 5px;
							border-radius: $border-radius;
							background-color: #F3F7FC;
						}

						.custom-upload {
							display: flex;
							align-items: center;
							width: 100%;
							height: 45px;
							padding: 5px;
							margin: 5px 0;
							border-radius: $border-radius;
							background-color: #FFF;
							font-size: .875em;
							cursor: pointer;

							.fake-input {
								width: 100%;
								overflow: hidden;
							}

							&:hover .fake-button {
								background-color: #2952AB;
							}

							.fake-button {
								flex-shrink: 0;
								width: 80px;
								height: 100%;
								padding: 5px;
								border-radius: $border-radius;
								text-align: center;
								color: #FFF;
								background-color: #3367D6;
							}

							input[type=file] {
								position: absolute;
								z-index: -1;
								opacity: 0;
							}
						}

						.acoes {
							margin-top: 10px;
							text-align: right;

							.import-btn {
								display: inline-block;
								width: 100%;
								padding: 5px 0;
								border-radius: $border-radius;
								background-color: #3367D6;
								text-decoration: none;
								text-align: center;
								color: #FFF;

								&:hover {
									background-color: #2952AB;
								}
							}
						}
					}
				}
			}

			&.list {
				grid-area: list;

				& > table {
					width: 100%;
					border-collapse: separate;
					border-spacing: 0 5px;

					tr {
						background-color: #F3F7FC;

						&:first-child {
							color: #FFF;

							th {
								background-color: $main-color;
								&:first-child {
									border-top-left-radius: $border-radius;
								}

								&:last-child {
									border-top-right-radius: $border-radius;
								}
							}
						}

						&:not(:first-child){
							cursor: pointer;

							&:hover {
								background-color: #BED1E8;
							}
						}
					}

					th, td {
						padding: 10px 5px;

						&.center {
							text-align: center;
						}

						&.right {
							text-align: right;
						}

						&.left {
							text-align: left;
						}
					}
				}
			}

			&.details {
				grid-area: details;
				margin-bottom: 5px;
				background-color: #F3F7FC;

				.container {
					position: sticky;
					top: 10px;

					& > div {
						padding: 10px;

						&.title {
							border-bottom: 1px solid #FFF;
							border-radius: $border-radius $border-radius 0 0;
							color: #FFF;
							background-color: $main-color;

							.fas {
								margin-right: 5px;
							}
						}

						&.content {
							span.detailed-info {
								display: block;

								b {
									display: block;
									font-weight: bold;
									font-size: .9em;
								}

								.error-box {
									max-height: 180px;
									overflow: auto;

									.error-item {
										display: block;
									}
								}
							}

							.download-status.downloading {
								display: inline-block;
								margin-left: 5px;
								animation: fa-spin 2s linear infinite;

								&::before {
									content: '\f110';
									font-family: 'Font Awesome 5 Free';
									font-weight: 900;
								}
							}
						}
					}
				}
			}
		}
	}
</style>

<style>
	/* Estilos de componentes externos */
	#importacoes .multiselect__single {
		margin-top: 5px;
	}

	#importacoes .multiselect__single, #importacoes .multiselect__input, #importacoes .multiselect__placeholder, #importacoes .fake-input {
		font-family: 'Roboto Condensed', 'Roboto', sans-serif;
		font-size: .875rem;
	}
</style>
